import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

// utils
import get from "lodash/get";
import set from "lodash/set";
import { mergeDefaultConfig } from "@features/sypi/actions";
import IconRefresh from "@assets/icons/IconRefresh";
import cloneDeep from "lodash/cloneDeep";
import { getJWT } from "@utils/browser-helpers";
// components
import InputField from "@components/ui/InputField";

const styles = {
  styleIconContainer: "inline-block h-[18px] ml-[7px]",
};

const GeneralInputField = ({ value, onChange, id, onBlur }) => {
  const sypiNewView = useSelector((state) => state.sypiNewView);
  const schemaAllView = useSelector((state) => state.schemaAllView);
  const { defaultConfig, fieldVisibility } = sypiNewView
    ? sypiNewView
    : schemaAllView;
  const formData = sypiNewView
    ? sypiNewView.sypiConfig
    : schemaAllView.schemaManagementConfig;

  const path = id
    .split(sypiNewView ? "_" : ".")
    .slice(1)
    .join(".");
  const defaultVal = get(defaultConfig, path);
  const returnNewConfig = () =>
    formData ? set(cloneDeep(formData), path, defaultVal) : cloneDeep(formData);
  const [inputVal, setInputVal] = useState(value);
  const pulledDiff = get(fieldVisibility, path);
  const [visible, setVisibility] = useState(pulledDiff || !inputVal);
  const dispatch = useDispatch();

  useEffect(() => {
    function syncStateValue() {
      if (value !== inputVal) {
        setInputVal(value);
      }
    }
    syncStateValue();
  }, [value, inputVal]);

  return (
    <>
      <div
        key={`${id}-container`}
        className={`style-icon-container ${styles.styleIconContainer}`}
      >
        {defaultVal !== inputVal && (
          <IconRefresh
            onClick={() => {
              let newConfig = returnNewConfig();
              setInputVal(defaultVal);
              dispatch(mergeDefaultConfig(newConfig));
            }}
          />
        )}
      </div>
      <InputField
        containerWidth="w-[17rem]"
        containerHeight="h-10"
        className={"general-input-container"}
        defaultContainerStyle={false}
        customId={id}
        onBlurCallback={onBlur}
        inputName={id.substring(id.lastIndexOf("_") + 1, id.length)}
        inputValue={inputVal && inputVal.toString()}
        onChangeCallback={(val) => {
          setInputVal(val);
          onChange(val);
        }}
        showColorSwab={false}
      />
      <div></div>
    </>
  );
};

export default GeneralInputField;
